import styled from 'styled-components/native';

export default styled.View`
  justify-content: space-between;
  min-height: 36%;
`;
